import React from "react"
import { TableCell, TableRow, Tooltip } from "@material-ui/core"
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import theme from "../../../theme"

type Props = {
    head: header[];
    action?: any;
    data: any[];
}

type header = {
    head: string;
    id: string;
    body?: (row: any) => string;
}

const StyledTableBodyCell = withStyles((theme: Theme) =>
    createStyles({
        root: {
            fontSize: "14px",
            textAlign: "center",
        }
    })
)(TableCell);

const StyledTableHeadCell = withStyles((theme: Theme) =>
    createStyles({
        root: {
            borderBottom: "2px solid #DADADA",
            fontWeight: 700,
            fontSize: "16px",
            textAlign: "center",
            '@media (max-width: 768px)': {
                fontSize: 10,
            },
        }
    })
)(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        table: {
            borderCollapse: "collapse",
            width: "100%",
        }
    }),
);

const SimpleTable = (props: Props) => {
    const classes = useStyles();

    return (
        <table className={classes.table}>
            <thead>
                <StyledTableRow>
                    {props?.head?.map((el: header) => (
                        <StyledTableHeadCell component="th">{el.head}</StyledTableHeadCell>
                    ))}
                    {props?.action && <StyledTableHeadCell component="th">{props?.action.head()}</StyledTableHeadCell>}
                </StyledTableRow>
            </thead>
            <tbody>
                {props?.data?.map((row: any) => (<StyledTableRow>
                    {props?.head?.map((el: header) => (<StyledTableBodyCell>{el.body ? el.body(row) : row[el.id]}</StyledTableBodyCell>))}
                    {props?.action && <StyledTableBodyCell>
                        {props?.action.body(row)}
                    </StyledTableBodyCell>}
                </StyledTableRow>))}
            </tbody>
        </table>
    )
}

export default SimpleTable;